<template>
  <div class="rt-collapse-transition">
    <div class="rt-collapse-transition-header" @click="collapseClick">
      <rt-icon
        :name="showContent ? 'rt-base-angle_up' : 'rt-base-angle_down'"
        size="18"
      />
      <p class="title">{{ title }}</p>
    </div>
    <el-collapse-transition>
      <div v-show="showContent" class="rt-collapse-transition-content">
        <slot />
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import ElCollapseTransition from '../../transitions/collapse-transition';
export default {
  name: 'RtCollapseTransition',
  components: {
    ElCollapseTransition
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showContent: this.show
    };
  },
  methods: {
    collapseClick(val) {
      this.showContent = !this.showContent;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCollapseTransition.vue?7fdbddce